import React, { Component } from 'react';
import { Grid, Button, Divider, Tab, Header, Icon, Modal, Label, List } from 'semantic-ui-react';
import PointTab from './tabs/point-tab';
import Support from './tabs/sign/support';
import 'semantic-ui-css/semantic.min.css';
import '../index.css';

import Activity from './tabs/sign/activity'
import SignPhotoGallery from './tabs/sign/photogallery';
import History from './tabs/sign/activityhistory'
import Panel from './tabs/sign/panel'
import Condition from './tabs/sign/conditionnew'

export default class ConstuctionSegment extends Component {

    // TODO create data model
    constructor(props) {
        super(props)
        console.log(this.props)
        if (this.props.loadData) {
            this.state = {
                SignLayer: this.props.loadData
            };
        }
        else {
            // This is a super data model class, its main function is to collect data from all the children components.
            this.state = {
                SignLayer: {
                    layer: 6,
                    layerName: 'Signs',
                    layerId: -1,
                    agencyId: -1, //to be determined later
                    point: {
                        id: -1, //id is not set, will be setting it soon.
                        point: '0,0',
                        signPanelId: '',
                        locationNote: ''
                    },
                    LocationDetails: {
                        roadName: null,
                        roadStart: null,
                        roadEnd: null,
                        offSet: null,
                        side: null,
                        station: null
                    },
                    Support: {
                        NumberofSupports: null,
                        SupportLength: null,
                        PostSize: null,
                        CreatedDate: null,
                        SupportType: null,
                        Breakaway: 0
                    },
                    Panel: {
                        data: []
                    },
                    Condition: {
                        conditionData: []
                    },
                    Activity: {
                        data: []
                    },
                    galleryModel: {
                        Comments: [],
                        datecreated: [],
                        key: [],
                        photpath: [],
                        photos: []
                    }
                }
            }
        }
        this.signOptions = {
            Inventory: 1,
            Activity: 2
        };

        this.setState({
            curValue: this.signOptions[this.props.prevPane]
        })
        this.startVal = this.signOptions[this.props.prevPane]

        console.log(this.props.prevPane)

        // these are the tabs.
        this.panes = {
            Inventory: [
                {
                    menuItem: 'Location', render: () =>
                        <Tab.Pane>
                            <PointTab triggerNeedSave={this.props.triggerNeedSave}
                                disabled={this.props.disabled} clickFunctions={this.props.clickFunctions}
                                pointModel={this.state.SignLayer} />
                        </Tab.Pane>
                },
                {
                    menuItem: 'Panel', render: () =>
                        <Tab.Pane>
                            <Panel triggerNeedSave={this.props.triggerNeedSave}
                                disabled={this.props.disabled} clickFunctions={this.props.clickFunctions}
                                pointModel={this.state.SignLayer}
                                needsave={this.props.needSave}
                                save={this.props.saveFn}
                                showSpinner={this.props.showSpinner}
                            />
                        </Tab.Pane>
                },
                {
                    menuItem: 'Support', render: () =>
                        <Tab.Pane>
                            <Support triggerNeedSave={this.props.triggerNeedSave}
                                disabled={this.props.disabled} clickFunctions={this.props.clickFunctions}
                                pointModel={this.state.SignLayer} />
                        </Tab.Pane>
                },
                {
                    menuItem: 'Condition', render: () =>
                        <Tab.Pane>
                            <Condition
                                triggerNeedSave={this.props.triggerNeedSave}
                                disabled={this.props.disabled} clickFunctions={this.props.clickFunctions}
                                pointModel={this.state.SignLayer} />
                        </Tab.Pane>
                },
                {
                    menuItem: 'Photo Gallery', render: () =>
                        <Tab.Pane>
                            <SignPhotoGallery
                                triggerNeedSave={this.props.triggerNeedSave}
                                disabled={this.props.disabled}
                                loggedIn={this.props.loggedin}
                                showLoadingSpinner={this.props.showSpinner}
                                pointModel={this.state.SignLayer} />
                        </Tab.Pane>
                }

            ],
            Activity: [
                {
                    menuItem: 'Activity', render: () =>
                        <Tab.Pane>
                            <Activity triggerNeedSave={this.props.triggerNeedSave}
                                disabled={this.props.disabled} clickFunctions={this.props.clickFunctions}
                                pointModel={this.state.SignLayer}
                                availabelPanels={this.props.availablepanels} />
                        </Tab.Pane>
                },
                {
                    menuItem: 'History', render: () =>
                        <Tab.Pane>
                            <History triggerNeedSave={this.props.triggerNeedSave}
                                disabled={this.props.disabled} clickFunctions={this.props.clickFunctions}
                                pointModel={this.state.SignLayer}
                                availabelPanels={this.props.availablepanels} />
                        </Tab.Pane>
                }

            ]
        };

        console.log(this.state.SignLayer)

        this.props.dataModel.splice(0, this.props.dataModel.length);
        this.props.dataModel.push(this.state.SignLayer);
    }
    renderGritLayerUI = () => {

        return (
            <div>
                <div>
                    {/* <Grid.Row>
                        <div className="pt-form-group pt-inline">
                            <label><b>Sign Layer</b></label>&nbsp;&nbsp;&nbsp;
                        </div>
                    </Grid.Row> */}
                    <Grid.Row>
                        <div className="btn-group">
                            <button id='inventoryBtn' style={(this.state.curValue == 1 || this.startVal == 1) ? {backgroundColor: '#2185d0', color: 'white', fontSize: "14px" } : { backgroundColor: '#e0e1e2', color: 'black', fontSize: "14px" }} value="1" onClick={this.onChangePane}>Inventory</button>
                            <button id='activityBtn' style={(this.state.curValue == 2 || this.startVal == 2) ? {backgroundColor: '#2185d0', color: 'white', fontSize: "14px" } : { backgroundColor: '#e0e1e2', color: 'black', fontSize: "14px" }} value="2" onClick={this.onChangePane}>Activity</button>
                        </div>
                    </Grid.Row>
                    <Divider />
                    <Grid.Row>
                        <Tab panes={this.state.pane} activeIndex={this.props.activeIndex} onTabChange={this.onTabChange} />
                    </Grid.Row>



                </div>

            </div>
        );
    }
    onTabChange = (e, data) => {
        this.props.updateActiveIndex(data.activeIndex);
    }
    componentDidMount() {
        this.setState({
            pane: this.panes[this.props.prevPane],
            inMaintenance: false
        });
    }
    onChangePane = (e) => {
        this.startVal = 0;
        const { target } = e;
        const { value } = target;
        //let pane = this.panes.Inventory;
        // eslint-disable-next-line
        if (parseInt(value) === 2) {
            this.setState({ pane: this.panes.Activity, inMaintenance: false, curValue: 2 }); //Something is going on here and I don't know what
            this.props.deleteDisabled(false);
            this.props.setPreviousPane('Activity');
        }
        else if (parseInt(value) === 1) {
            this.setState({ pane: this.panes.Inventory, inMaintenance: false, curValue: 1 });
            this.props.deleteDisabled(false);
            this.props.setPreviousPane('Inventory');
        }

        this.onTabChange(null, { activeIndex: 0 });
        console.log("here 5")
        //console.log("pane changed " + value);
    }

    render() {
        return this.renderGritLayerUI();
    }
}


// WEBPACK FOOTER //
// ./src/layers/signs.js